import React, { useState } from 'react';
import { MsalProvider } from '@azure/msal-react';
import { GlobalErrorContext } from './globalErrorContext';
import { msalInstance } from 'msalConfig/msalConfig';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import store from 'services/store';
import { GlobalErrorModal } from 'app/components/GlobalErrorModal';
import InitializationError from 'app/components/GlobalErrorModal/InitializationError';

interface Props {
  children: React.ReactNode;
}

// TODO: Perform a proper refactor of the context provider architecture.
// The `ServiceProviders` and `BusinessLogicProviders` components below are a temporary
// first-pass refactor. They were created by simply splitting the monolithic `ReactContextContainer`
// to improve the separation of concerns. Further work is needed to clean up dependencies
// and streamline the initialization flow.
export default function ServiceProviders({ children }: Props) {
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [isAppInitializationError, setIsAppInitializationError] =
    useState(false);

  const addErrorModal = () => {
    setShowErrorModal(true);
  };

  const closeErrorModal = () => {
    setShowErrorModal(false);
  };

  function showAppInitializationErrorModal() {
    setIsAppInitializationError(true);
  }

  return (
    <Provider store={store}>
      <HelmetProvider>
        <MsalProvider instance={msalInstance}>
          <GlobalErrorContext.Provider
            value={{
              showAppInitializationErrorModal,
              addErrorModal,
              closeErrorModal,
              showErrorModal,
            }}
          >
            {isAppInitializationError && <InitializationError />}
            {showErrorModal && !isAppInitializationError && (
              <GlobalErrorModal onClose={closeErrorModal} />
            )}

            <HashRouter>{children}</HashRouter>
          </GlobalErrorContext.Provider>
        </MsalProvider>
      </HelmetProvider>
    </Provider>
  );
}
